import { Model } from 'pinia-orm';
import Stage from './Stage';
import TimelineEvent from './TimelineEvent';
import Interim from './Interim';
import Interview from './Interview';
import Document from './Document';
import Subscription from './Subscription';
import moment from 'moment';
import styles from '../../../../../styles.config';
import ApplicationField from './ApplicationField';
import Tag from './Tag';
import Taggable from "./Taggable";
import CompetenceTemplate from "./CompetenceTemplate";
import Job from "./Job";
import InterviewTemplate from "./InterviewTemplate";

export default class Application extends Model {

    static entity = 'applications';

    static fields() {
        return {
            id: this.uid(),
            company_id: this.attr(null),
            stage_id: this.attr(null),
            original_stage_id: this.attr(null),
            rejected: this.boolean(false),
            phone_number: this.attr(''),
            birthdate: this.attr(''),
            birthplace: this.attr(''),
            country: this.attr(''),
            city: this.attr(''),
            postal_code: this.attr(''),
            street: this.attr(''),
            house_number: this.attr(''),
            email: this.attr(''),
            image_url: this.attr(''),
            photo_path: this.attr(''),
            first_name: this.attr(''),
            last_name: this.attr(''),
            salary_expectation: this.attr(''),
            rijksregister_nr: this.attr(''),
            iban_nr: this.attr(''),
            locale: this.attr('en'),
            dynamic_questions: this.attr({}),
            dynamic_questions_interim: this.attr({}),
            motivation: this.string(''),
            score: this.number(null),
            officient_id: this.attr(null),
            added_to_officient: this.boolean(false),
            completed_at: this.attr(null),
            data_retention_period: this.number(null),
            expires_in: this.number(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            is_demo_data: this.attr(false),
            linkedin: this.attr(false),
            instagram: this.attr(false),
            facebook: this.attr(false),
            twitter: this.attr(false),
            tasks_count: this.attr(0),
            referrer: this.attr(null),
            referrer_source: this.attr(null),
            interim_candidate_id: this.attr(null),
            interim_id: this.attr(null),
            favorite: this.boolean(false),

            //relationships
            stage: this.belongsTo(Stage, 'stage_id'),
            'original_stage': this.belongsTo(Stage, 'original_stage_id'),
            'timeline_events': this.hasMany(TimelineEvent, 'application_id'),
            interviews: this.hasMany(Interview, 'application_id'),
            interim: this.belongsTo(Interim, 'interim_id'),
            documents: this.hasMany(Document, 'application_id'),
            subscriptions: this.morphMany(Subscription, 'subable_id', 'subable_type'),
            tags: this.morphToMany(Tag, Taggable, 'tag_id', 'taggable_id', 'taggable_type'),
            related_app_ids: this.attr([]),
            related_applications: this.hasManyBy(Application, 'related_app_ids'),
            application_fields: this.hasMany(ApplicationField, 'application_id'),

            competence_template: this.hasManyThrough(CompetenceTemplate, Job, 'id', 'id', 'job_id', 'competence_template_id'),
            interview_template: this.hasManyThrough(InterviewTemplate, Job, 'id', 'id', 'job_id', 'interview_template_id')
        };
    }

    static mutators() {
        return {
            motivation: {
                get: value => value == null ? '' : value,
                set: value => value === '' ? null : value,
            },
        };
    }

    get initials() {
        return (this.first_name ? this.first_name.charAt(0) : '') + (this.last_name ? this.last_name.charAt(0) : '');
    }

    get fullName() {
        return this.first_name + ' ' + this.last_name;
    }

    get createdMoment() {
        return moment(this.created_at);
    }

    get stageColor() {

        if (this.rejected) {
            return styles.colors.semantic.error.DEFAULT;
        }

        if (!this.stage) {
            return styles.colors.primary[20];
        }

        return this.stage.color || styles.colors.primary[20];
    }

    get scoreColor() {

        if (this.score === null) {
            return styles.colors.primary[80];
        }

        const colors = [styles.colors.semantic.error.dark, styles.colors.semantic.error.DEFAULT, styles.colors.semantic.warning.DEFAULT, styles.colors.semantic.success.DEFAULT, styles.colors.semantic.success.dark];
        const colorIndex = Math.min(Math.max(Math.floor(this.score / 20), 0), 4);

        return colors[colorIndex];
    }
}
